<!-- eslint-disable max-lines -->
<!-- 收入概览 -->
<template>
    <div class="page org-income">
        <div class="page-content">
            <!-- 条件筛选 -->

            <box :showheader="false" class="box-custom search-box">
                <div class="page-content-top">
                    <searchList :searchListConfig="searchListConfig" :roleCodes="roleCodes" :currentRole="currentRole"
                        :currentUserName="currentUserName" @resetCurrent="resetCurrent"
                        :searchOptionsList="searchOptionsList" @search-handle="searchHandle"
                        :searchInitData="searchInitData" />
                    <update-time @reset-current="resetCurrent" :updateTimeBigdataList="updateTimeBigdataList" />
                </div>
            </box>
            <!-- 客户KPI及客诉 -->
            <div class="customer-content mt10">
                <customer-complaint class="content-left" :currentRole="currentRole" :config="customerConfig.complaint" :customerData="complaintData"
                :showMoreLink="false" />
            </div>

            <!-- 外部客户达成率统计表 -->
            <box title="外部客户达成率统计表" class="mt10 box-custom" v-loading="customerLoading" :showHeaderUnit="false">
                <el-radio-group class="search-radio" v-model="customerRadioValue" size="mini">
                    <el-radio-button v-for="item in customerType.radioGroup" :key="item.value" :label="item.value">{{
                        item.label }}</el-radio-button>
                </el-radio-group>
                <table-item   ref="customerTableRef" :nededFormatValue="false"
                    :version="computedCustomerRadioValue"
                    :beforeRequest="customerRequestConfig.beforeRequest"
                    :afterRequest="customerRequestConfig.afterRequest"
                    class="overview-table"
                    :height="customerColumnConfig.height" :columns="calcCustomerColumn.columns"
                    :params="customerParams">
                    <template v-slot:col-append="{ col, row }">
                    </template>
                </table-item>
            </box>

            <!-- 客户KPI明细 -->
            <box title="客户KPI明细" class="box-custom" v-loading="customerKpiLoading" :showHeaderUnit="false">
                <table-item
                    :nededFormatValue="false"
                    :show-pagination="true" ref="customerKpiTableRef"
                    :beforeRequest="customerKpiRequestConfig.beforeRequest"
                    :height="customerKpiColumnsConfig.height"
                    :columns="customerKpiColumn.columns"
                    :params="customerKpiParams">
                    <template v-slot:col-append="{ col, row }">
                    </template>
                </table-item>
            </box>

            <!-- 重大客诉 -->
            <box title="重大客诉" v-loading="complaintDetailLoading" :showHeaderUnit="false">
                <table-item  ref="complaintDetailTableRef"
                    :nededFormatValue="false"
                    :beforeRequest="complaintDetailRequestConfig.beforeRequest"
                    :default-sort="complaintDetailColumnsConfig.defaultSort"
                    :height="complaintDetailColumnsConfig.height"
                    :columns="calcComplaintDetailColumn.columns" :params="complaintDetailParams">
                    <template v-slot:col-append="{ col, row }">
                    </template>
                </table-item>
            </box>

        </div>

    </div>
</template>
<script>
import { ref, onMounted, computed, watch, getCurrentInstance, onActivated } from '@vue/composition-api';
import searchList from '@/views/index/searchList/Index.vue';
import { getUserRoleList, queryUserDataAuth, getCustomerComplaint } from '@/api/homePageApi';
import store from '@/store';
import updateTime from '@/views/components/UpdateTime.vue';
import box from '@/views/components/Box.vue';
import {
    customerColumnConfig, customerKpiColumnsConfig, complaintDetailColumnsConfig, searchListConfig,
    updateTimeBigdataList
} from './column.config.js';
import { whileList, custoemrComplaintConfig } from '../../../index/config.js';
import _ from 'lodash';
import tableItem from '@/views/subPage/component/TableItem.vue';
import homeBgPic from '@/assets/images/homeBg.png';
import { getCustomerAchievement, getCustomerComplaintDetail, getCustomerKpiDetail } from '@/api/subPageApi.js';
import { getSession } from '@/components/utils/storage';
import customerComplaint from '@/views/index/customerComplaint/Index.vue';
export default {
    components: {
        searchList,
        updateTime,
        box,
        tableItem,
        customerComplaint
    },
    // eslint-disable-next-line max-lines-per-function
    setup(props, setupContext) {
        const { userCode } = store.getters.user;
        const customerTableRef = ref(null);
        const customerKpiTableRef = ref(null);
        const complaintDetailTableRef = ref(null);
        const currentRole = ref({});
        const currentUserName = ref('');
        const roleCodes = ref([]);
        const searchOptionsList = ref({});
        // 顶部筛选条件
        const searchData = ref({});

        // 外部客户达成率统计表况
        const customerRadioValue = ref(`分公司`);
        const customerType = ref({
            radioValue: `分公司`,
            radioGroup: [
            //     {
            //     value: `行业`,
            //     label: '行业'
            // },
                {
                    value: '分公司',
                    label: '分公司'
                }, {
                    value: '经营中心',
                    label: '经营中心'
                }
            // {
            //     value: '客户系',
            //     label: '客户系'
            // }
            ]
        });

        const getPersonalParams = () => {
            const param = _.pick(currentRole.value, ['roleName', 'roleCode']);
            param.roleType = currentRole.value.dataType;
            return param;
        };
        // 临时方案 0205删除
        const changeCustomerLevel = (customerlevelName) => {
            if (customerlevelName === 'CKA') {
                customerlevelName = '行业CKA';
            }
            return customerlevelName;
        };
        // 公用参数
        const getParams = computed(() => {
            return {
                refresh: true,
                transactionClassCode: `'2'`, // 默认外部
                serviceProductCode: `'all'`,
                organizationCode: `'all'`,
                industryTypeCode: `'all'`,
                userCode: userCode, // 测试账号
                dataType: isYear.value ? 'Y' : 'M',
                dataTime: isYear.value ? searchData.value.yearTime : searchData.value.monthTime,
                costType: isYear.value ? '2' : searchData.value.costType,
                // customerlevelName: searchData.value.customerlevelName, // 临时方案 0205恢复
                customerlevelName: changeCustomerLevel(searchData.value.customerlevelName), // 临时方案 0205删除
                ebcdCode: searchData.value.ebcdCode,
                typeId: searchData.value.typeId,
                areaCode: searchData.value.areaCode,
                subBranchCode: searchData.value.subBranchCode,
                businessSceneBigCategory: searchData.value.businessSceneBigCategory
            };
        });

        // 外部客户达成率统计表入参
        const customerParams = computed(() => {
            return {
                ..._.pick(getParams.value, [
                    'refresh',
                    'dataType',
                    'dataTime',
                    'costType',
                    'userCode',
                    'ebcdCode',
                    'businessSceneBigCategory',
                    'typeId',
                    'areaCode',
                    'subBranchCode',
                    'serviceProductCode',
                    'transactionClassCode',
                    'organizationCode'
                ]),
                customerLevelName: getParams.value.customerlevelName,
                // getApiKey: getApiKey.value,
                angleType: customerRadioValue.value,
                api: getCustomerAchievement,
                ...getPersonalParams()
            };
        });

        // 客户KPI明细入参
        const customerKpiParams = computed(() => {
            return {
                ..._.pick(getParams.value, [
                    'ebcdCode',
                    'typeId',
                    'areaCode',
                    'subBranchCode',
                    'businessSceneBigCategory',
                    'dataTime',
                    'dataType',
                    'userCode',
                    'transactionClassCode'
                    // 'serviceProductCode',
                    // 'organizationCode'
                ]),
                customerLevelName: getParams.value.customerlevelName,
                // getApiKey: getApiKey.value,
                api: getCustomerKpiDetail,
                ...getPersonalParams()
            };
        });
        // 重大客诉入参
        const complaintDetailParams = computed(() => {
            return {
                ..._.pick(getParams.value, [
                    'ebcdCode',
                    'typeId',
                    'areaCode',
                    'subBranchCode',
                    'businessSceneBigCategory',
                    'dataTime',
                    'dataType',
                    'userCode',
                    'transactionClassCode'
                ]),
                customerLevelName: getParams.value.customerlevelName,
                // getApiKey: getApiKey.value,
                api: getCustomerComplaintDetail,
                ...getPersonalParams()
            };
        });

        const isYear = computed(() => {
            return searchData.value?.timeStatus === 'year';
        });

        // 表格loading状态统一管理
        const getTableLoading = (tableRef) => computed(() => tableRef.value?.tableListInstance?.tableLoading);
        // 外部客户达成率统计表况loading
        const customerLoading = getTableLoading(customerTableRef);
        // 外部客户达成率统计表loading
        const customerKpiLoading = getTableLoading(customerKpiTableRef);
        // 重大客诉loading
        const complaintDetailLoading = getTableLoading(complaintDetailTableRef);

        // 外部各行业请求配置
        const customerRequestConfig = {
            beforeRequest: (condition) => {
                return customerParams.value;
            },
            afterRequest: (res) => {
                if (res && +res.code === 0) {
                    const props = calcCustomerColumn.value.columns.map(col => col.prop);
                    const emptyValues = [null, undefined, '', '99900.00%'];
                    const data = res.data.list.map(item => {
                        const newItem = { ...item };
                        props.forEach(prop => {
                            if (emptyValues.includes(newItem[prop])) {
                                newItem[prop] = '-';
                            }
                        });
                        return newItem;
                    });
                    return {
                        data,
                        total: res.data.totalCount
                    };
                }
            }
        };

        // KPI明细请求配置
        const customerKpiRequestConfig = {
            beforeRequest: (condition) => {
                return customerKpiParams.value;
            }
        };
        // 重大客诉请求配置
        const complaintDetailRequestConfig = {
            beforeRequest: (condition) => {
                // 这里接口是从0开始分页的
                const { pageNo, pageSize } = condition;
                return { ...complaintDetailParams.value, ...{ pageNo, pageSize } };
            }
        };

        const customerColumn = ref(customerColumnConfig);
        const customerKpiColumns = ref(customerKpiColumnsConfig);
        const complaintDetailColumns = ref(complaintDetailColumnsConfig);

        const radioColumn = {
            '行业': 'industryColumns',
            '分公司': 'companyColumns',
            '经营中心': 'businessCenterColumns',
            '客户系': 'seriesColumns'
        };
        // 外部客户达成率统计表表格字段
        const calcCustomerColumn = computed(() => {
            return {
                columns: customerColumn.value[radioColumn[customerRadioValue.value]]
            };
        });
        // 动态切换列的时候用传入version进行列的key区分
        const computedCustomerRadioValue = computed(() => {
            return customerRadioValue.value + getParams.value.dataTime;
        });

        // KPI明细表格字段
        const customerKpiColumn = computed(() => {
            const { columns } = customerKpiColumns.value;
            return {
                columns
            };
        });

        // 重大客诉表格字段
        const calcComplaintDetailColumn = computed(() => {
            const { columns } = complaintDetailColumns.value;
            return {
                columns
            };
        });

        const setStrFormat = (val) => {
            if (!Array.isArray(val)) return val;
            return val?.map(item => `'${item}'`).join(',') || '';
        };

        const setCommaStrFormat = (val) => {
            let str = '';
            for (let i = 0; i < val.length; i++) {
                if (val[i].indexOf(',') >= 0) {
                    const arr = val[i].split(',');
                    for (let j = 0; j < arr.length; j++) {
                        str += "'" + arr[j] + "',";
                    }
                } else {
                    str += "'" + val[i] + "',";
                }
            }
            return str.substring(0, str.length - 1); // 删除最后的逗号
        };

        // 筛选赋值
        const searchHandle = (val) => {
            searchData.value = _.cloneDeep(val);
            if (val.industryCategory?.length) {
                searchData.value.typeId = val.industryCategory.map(it => it[0]);
            } else {
                searchData.value.typeId = [];
            }

            searchData.value.ebcdCode = setCommaStrFormat(searchData.value.ebcdCode) || "'all'"; // 专业公司编码
            searchData.value.typeId = setStrFormat(searchData.value.typeId) || "'all'"; // 行业大类
            searchData.value.areaCode = setStrFormat(searchData.value.areaCode) || "'all'"; // 片区
            searchData.value.subBranchCode = setStrFormat(searchData.value.subBranchCode) || "'all'"; // 分公司
            searchData.value.businessSceneBigCategory = setStrFormat(searchData.value.businessSceneBigCategory) || "'all'"; // 业务场景
            getAllData();
        };

        // 获取页面所有数据
        const getAllData = () => {
            Promise.all([getCustomerComplaintInfo()]);
        };
        const getApiKey = ref(1);
        const resetCurrent = () => {
            getApiKey.value++;
            getAllData(true);
        };
        const currentUserMip = ref('');
        // 获取用户角色list
        const getUserRoleInfo = () => {
            if (currentRole.value.dataType && store.getters.homePageParams?.dataType !== 'personal') return;
            const currentRoleHome = getSession('currentRoleHome');
            if (store.getters.homePageParams?.dataType || currentRoleHome?.dataType) {
                const _currentRole = _.pick(store.getters.homePageParams, [
                    'roleCode',
                    'roleName',
                    'dataType',
                    'sortNo'
                ]);
                currentRole.value = _currentRole.dataType ? _currentRole : currentRoleHome;
                return;
            }
            const params = { userCode: userCode };
            if (currentRole.value) {
                params.userRoleDataType = currentRole.value.dataType;
            }

            return getUserRoleList(params).then(res => {
                if (res && +res.code === 0) {
                    currentUserMip.value = res.data.userCode;
                    currentUserName.value = res.data.userName;
                    roleCodes.value = res.data.roleCodes;
                    if (Array.isArray(roleCodes.value) && roleCodes.value?.length) {
                        currentRole.value = roleCodes.value[0];
                    }
                    if (currentRole.value.dataType === 'personal') {
                        // _opportunityConfig.value = statusList.opportunityList.filter(it => it.role.includes(String(currentRole.value.dataType)));
                    } else {
                        // customerStatusList.value = statusList.customerList.filter(it => it.role.includes('organization'));
                        // _opportunityConfig.value = statusList.opportunityList.filter(it => it.role.includes('organization'));
                    }
                    // customerActive.value = customerStatusList.value[0].type;
                } else {
                    // resetLoading.value = false;
                }
            }).catch(() => {
                // resetLoading.value = false;
            }).finally(() => {
                // homePageShow.value = true;
            });
        };
        const ctx = getCurrentInstance();
        const searchInitData = ref({});
        const getUserDataInfo = () => {
            // searchInitData.value = {};
            const params = {
                ...currentRole.value,
                roleType: currentRole.value.dataType
            };
            return queryUserDataAuth(params).then(res => {
                if (res && +res.code === 0) {
                    currentUserMip.value = res.data.userCode;
                    currentUserName.value = res.data.userName;
                    searchOptionsList.value = res.data;
                    searchInitData.value = store.getters.homePageParams;
                }
            });
        };

        const customerConfig = computed(() => {
            const { satisfaction, complaintOrg, complaintPersonal } = custoemrComplaintConfig;
            if (currentRole.value.dataType === 'personal') {
                complaintPersonal.headConfig[0].title = complaintTitle.value + 'KPI得分';
                complaintPersonal.headConfig[1].title = complaintTitle.value + 'KPI排名';
            } else {
                complaintOrg.headConfig[0].title = complaintTitle.value + 'KPI得分';
                complaintOrg.headConfig[1].title = complaintTitle.value + 'KPI排名';
            }
            return {
                complaint: currentRole.value.dataType === 'personal' ? complaintPersonal : complaintOrg,
                satisfaction: satisfaction
            };
        });
        // 格式化数据- -
        const setCustomerFormatData = (data, initData) => {
            const _data = {};
            for (const item in initData) {
                if (initData.hasOwnProperty(item)) {
                    _data[item] = _.get(data, item, '-');
                }
            }
            return _data;
        };
        const initComplaintData = {
            kpiAchievementRate: '',
            kpiAchievementRank: '',
            majorSumCnt: '',
            majorComplaintsCnt: '',
            majorAccountabilityCnt: ''
        };
        // KPI以及客诉
        const complaintData = ref(_.cloneDeep(initComplaintData));
        const complaintTitle = ref('');
        const getCustomerComplaintInfo = () => {
            const params = {
                ..._.pick(getParams.value, [
                    'ebcdCode',
                    'typeId',
                    'areaCode',
                    'subBranchCode',
                    'businessSceneBigCategory',
                    'dataTime',
                    'angleType',
                    'refresh',
                    'transactionClassCode',
                    'serviceProductCode',
                    'organizationCode',
                    'userCode',
                    'dataType'
                ]),
                customerLevelName: getParams.value.customerlevelName,
                ...getPersonalParams()
            };
            getCustomerComplaint(params).then(res => {
                if (res && +res.code === 0) {
                    complaintData.value = setCustomerFormatData(res.data, initComplaintData);
                    complaintTitle.value = _.get(res.data, 'kpiTitle', '');
                } else {
                    complaintData.value = setCustomerFormatData({}, initComplaintData);
                }
            }).catch(() => {
                complaintData.value = setCustomerFormatData({}, initComplaintData);
            });
        };

        onMounted(async () => {
            document.querySelector('.el-main').style['background']
                = `linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255,1)),url(${homeBgPic}) center / 100% 100% no-repeat`;
        });
        onActivated(async () => {
            await getUserRoleInfo();
            await getUserDataInfo();
        });

        watch(
            () => ctx.$route,
            (newVal) => {
                if (!whileList.includes(newVal.name) && document.querySelector('.el-main')) {
                    document.querySelector('.el-main').style['background'] = '#f3f4f6';
                } else if (document.querySelector('.el-main')) {
                    document.querySelector('.el-main').style['background']
                        = `linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255,1)),url(${homeBgPic}) center / 100% 100% no-repeat`;
                }
            },
            { immediate: true } // 不设置的话，初始化加载时不会执行
        );
        return {
            searchHandle,
            resetCurrent,
            currentRole,
            currentUserName,
            roleCodes,
            searchOptionsList,
            customerColumnConfig,
            customerKpiColumnsConfig,
            complaintDetailColumnsConfig,
            customerType,
            searchData,
            customerParams,
            customerKpiParams,
            isYear,
            complaintDetailParams,
            searchInitData,
            customerRequestConfig,
            customerKpiRequestConfig,
            complaintDetailRequestConfig,
            customerTableRef,
            customerKpiTableRef,
            complaintDetailTableRef,
            customerRadioValue,
            searchListConfig,
            getParams,
            updateTimeBigdataList,
            calcCustomerColumn,
            customerKpiColumn,
            calcComplaintDetailColumn,
            currentUserMip,
            customerLoading,
            customerKpiLoading,
            complaintDetailLoading,
            customerConfig,
            complaintData,
            computedCustomerRadioValue
        };
    }
};
</script>
<style scoped lang="less">
.page {
    min-width: 1500px;
    width: 100%;

    &-content {
        width: 100%;
        padding: 0 0 10px 0;

        // 按钮组
        .search-radio {
            margin-bottom: 10px;

            // 深度选择
            /deep/ .el-radio-button__inner {
                padding: 5px 15px;
            }

            /deep/ .el-radio-button__orig-radio:checked+.el-radio-button__inner {
                color: #2881FF;
                border-color: #2881FF;
                background-color: #E5F0FE;
            }

            /deep/ .el-radio-button:first-child:last-child .el-radio-button__inner {
                border-radius: 0px 2px 2px 0px !important;
            }
        }

        .search-box {
            position: sticky;
            top: 0;
            z-index: 100;
            backdrop-filter: blur(25px);
            background: linear-gradient(180deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0.9) 100%);
            box-shadow: 0 2px 8px rgba(136, 136, 136, 0.1);
        }

        .box-custom {
            margin-bottom: 10px;
        }

        .page-content-top {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
    }
}
.customer-content{
    display: flex;
    flex-direction: row;
    .content-left,.content-right{
        background-color: #fff;
        padding: 16px 16px 18px 16px;
        border-radius: 4px;
        box-shadow: 0 2px 8px rgba(136, 136, 136, 0.1);
        flex: 1;
    }
    .content-left{
        margin-right: 5px;
    }
   .content-right{
        margin-left: 5px;
   }
}
.mt10{
    margin-top: 10px;
}
</style>
